import {
  OrderTemplateDto,
  OrderTemplatesApi
} from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';

export default class OrderTemplateApiService {
  private static instance: OrderTemplateApiService = null;

  public static singleton(): OrderTemplateApiService {
    if (this.instance == null) {
      this.instance = new OrderTemplateApiService();
    }

    return this.instance;
  }

  private orderTemplateApi: OrderTemplatesApi;

  private constructor() {
    this.orderTemplateApi = ApiService.wrap(OrderTemplatesApi);
  }

  public async fetchOrderTemplates(): Promise<OrderTemplateDto[]> {
    return await this.orderTemplateApi.getOwnOrderTemplates(
      ConfigService.getTenant(),
      ConfigService.currentCustomerIdOrNull
    );
  }
}
